import { FC } from "react"
import { useNavigate } from "react-router-dom"
import "./styles.scss";
import { Header } from "../Header";
import { useTranslation } from "../../../hooks/useTranslation";
import { useLandingLanguage } from "../../../hooks/useLandingLanguage";
import mockupDesktop from "../../../assets/images/landing/app-mockup-desktop.png";
import { isPublicNext } from "../../../next/public/mode";
import { LegacyWayBack } from "../../../next/public/LegacyWayBack";
import { HomePage } from "../../../next/public/HomePage";
import mockupMobile from "../../../assets/images/landing/app-mockup-mobile.png";

export const Layout: FC = () => {
  const { p } = useTranslation('first_page');
  const navigate = useNavigate()

  const toWelcome = () => {
    navigate("/welcome")
  }

  const { locale, handleLanguageChange } = useLandingLanguage();
  if (isPublicNext()) return <HomePage />;

  return (
    <div className="landing-page-layout">
      <Header locale={locale} onLanguageChange={handleLanguageChange} />

      <div className="landing-page-layout__hero">
        <h1 className="landing-page-layout__headline">{p('hero_headline')}</h1>
        <p className="landing-page-layout__subtitle">{p('hero_subtitle')}</p>

        <button
          type="button"
          className="landing-page-layout__hero-cta"
          onClick={toWelcome}
        >
          {p('get_started')}
        </button>

        <picture className="landing-page-layout__mockup">
          <source media="(min-width: 901px)" srcSet={mockupDesktop} />
          <img
            src={mockupMobile}
            alt="connectyid app map and outreach dashboard"
            className="landing-page-layout__mockup-img"
          />
        </picture>
      </div>
      <LegacyWayBack />
    </div>
  )
}
